<template>
    <el-dialog
        v-dialogDrag
        :closeOnClickModal='false'
        :before-close="beforeClose"
        title="蓝月亮打印"
        width="30%"
        :visible="true">
        <el-button v-for="(item, index) in bluemoonList" :key="index" @click="print(item)">
            {{ item.deliveryCode}}
        </el-button>
    </el-dialog>
</template>

<script>
export default {
    props: {
        bluemoonPrintShow: {
            type: Boolean,
            default: false
        },
        bluemoonList: {
            type: Array,
            default() {
                return [];
            }
        },
        BLUE_MOON_PSD_URL: {
            type: String,
            default: ''
        }
    },
    methods: {
        beforeClose() {
            this.$emit('update:bluemoonPrintShow', false);
        },
        print(item) {
            window.open(this.BLUE_MOON_PSD_URL + item.url);
        }
    }
};
</script>

<style lang="less" scoped>
.el-button {
    margin: 0;
    margin-bottom: 10px;
}
/deep/ .el-dialog__body {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
}
</style>